// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

export var ROOT_FONT_SIZE = '16px';
export var NAV_BAR_HEIGHT = '60px';
export var NAV_ITEM_INNER_SPACING_X = '8px';
export var NAV_ITEM_PADDING_LEFT = '12px';
export var NAV_ITEM_PADDING_RIGHT = '12px';
export var NAV_ITEM_PADDING_X = '24px';
export var NAV_ITEM_PADDING_Y = '12px';
export var ALERT_FONT_SIZE = '14px';
export var SMALL_CLOSE_BUTTON_SIZE = '8px';
export var MEDIUM_CLOSE_BUTTON_SIZE = '12px';
export var EXTRA_LARGE_CLOSE_BUTTON_SIZE = '36px';
export var CHEVRON_FONT_SIZE = '12px';
export var EMPTY_STATE_PADDING_X = '56px';
export var EMPTY_STATE_PADDING_Y = '20px';
export var DISTANCE_MEASUREMENT_EXTRA_SMALL = '8px';
export var DISTANCE_MEASUREMENT_SMALL = '12px';
export var DISTANCE_MEASUREMENT_MEDIUM = '24px';
export var DISTANCE_MEASUREMENT_LARGE = '32px';
export var DISTANCE_MEASUREMENT_EXTRA_LARGE = '64px';
export var DRAG_HANDLE_HEIGHT = '24px';
export var DRAG_HANDLE_OFFSET_Y = '12px';
export var DRAG_HANDLE_OFFSET_X = '9px';
export var DRAG_HANDLE_WIDTH = '5px';
export var INPUT_FONT_SIZE = '16px';
export var INPUT_SM_FONT_SIZE = '14px';
export var INPUT_BORDER_WIDTH = '1px';
export var INPUT_DEFAULT_PADDING_X = '10px';
export var INPUT_DEFAULT_PADDING_Y = '10px';
export var INPUT_DEFAULT_HEIGHT = '40px';
export var INPUT_SM_HEIGHT = '32px';
export var SLIDER_CONTROL_SIZE = '20px';
export var LABEL_DEFAULT_PADDING_TOP = '8px';
export var LABEL_DEFAULT_PADDING_BOTTOM = '4px';
export var BASE_FONT_SIZE = '14px';
export var BASE_LINE_HEIGHT = '24px';
export var BASE_SINGLE_DIRECTION_MARGIN = '16px';
export var BASE_SPACING_X = '12px';
export var BASE_SPACING_Y = '6px';
export var BASE_ICON_SPACING_X = '8px';
export var INLINE_ICON_SPACING_X = '4px';
export var HEADING1 = '32px';
export var HEADING2 = '24px';
export var HEADING3 = '22px';
export var HEADING4 = '20px';
export var HEADING5 = '16px';
export var HEADING6 = '14px';
export var HEADING7 = '14px';
export var PAGE_TITLE_FONT_SIZE = '20px';
export var MICROCOPY_SIZE = '12px';
export var MICROCOPY_LINE_HEIGHT = '18px';
export var FORM_COPY_SIZE = '16px';
export var FORM_SET_VALIDATION_TOP_SPACING = '4px';
export var FORM_SET_VERTICAL_SEPARATION = '12px';
export var BUTTON_BORDER_WIDTH = '1px';
export var BUTTON_XS_FONT_SIZE = '12px';
export var BUTTON_SM_FONT_SIZE = '12px';
export var BUTTON_DEFAULT_FONT_SIZE = '14px';
export var BUTTON_LG_FONT_SIZE = '44px';
export var BUTTON_DEFAULT_PADDING_X = '24px';
export var BUTTON_DEFAULT_PADDING_Y = '12px';
export var BUTTON_XS_WIDTH = '26px';
export var BUTTON_XS_PADDING_X = '12px';
export var BUTTON_XS_PADDING_Y = '6px';
export var BUTTON_SM_WIDTH = '32px';
export var BUTTON_SM_PADDING_X = '16px';
export var BUTTON_SM_PADDING_Y = '9px';
export var BUTTON_LG_WIDTH = '40px';
export var BUTTON_LG_PADDING_X = '18px';
export var BUTTON_LG_PADDING_Y = '17px';
export var BUTTON_RADIUS = '3px';
export var PAGINATION_BUTTON_FONT_SIZE = '14px';
export var PAGINATION_BUTTON_LABEL_FONT_SIZE = '14px';
export var SELECTABLE_BUTTON_MAX_WIDTH = '200px';
export var SELECTABLE_BUTTON_LARGE_MIN_HEIGHT = '180px';
export var SELECTABLE_BUTTON_SMALL_HEIGHT = '56px';
export var TABLE_DEFAULT_FONT_SIZE = '14px';
export var TABLE_DEFAULT_PADDING_Y = '16px';
export var TABLE_DEFAULT_PADDING_X = '24px';
export var TABLE_CELL_HEIGHT = '72px';
export var TABLE_HEADER_FONT_SIZE = '12px';
export var TABLE_HEADER_PADDING_Y = '14px';
export var TABLE_HEADER_PADDING_TOP = '8px';
export var TABLE_HEADER_PADDING_BOTTOM = '4px';
export var TABLE_HEADER_HEIGHT = '44px';
export var TABLE_COMPACT_PADDING_Y = '8px';
export var TABLE_COMPACT_HEADER_HEIGHT = '56px';
export var TABLE_COMPACT_CELL_HEIGHT = '56px';
export var CARD_PADDING = '40px';
export var CARD_PADDING_COMPACT = '24px';
export var CARD_SHADOW_ALPHA = '.12';
export var CARD_SHADOW_BLUR_RADIUS = '5px';
export var CARD_SHADOW_OFFSET_Y = '1px';
export var ALERT_PADDING = '20px';
export var ALERT_PADDING_X = '20px';
export var ALERT_PADDING_Y = '8px';
export var ALERT_HEIGHT = '60px';
export var DROP_SMALL_HEIGHT = '72px';
export var DROP_LARGE_HEIGHT = '198px';
export var INLINE_DIVIDED_LIST_SPACING_X = '8px';
export var MODAL_HEADER_HEIGHT = '68px';
export var MODAL_HEADER_PADDING_X = '40px';
export var MODAL_BODY_PADDING_X = '40px';
export var MODAL_BODY_PADDING_Y = '40px';
export var MODAL_FOOTER_PADDING_X = '40px';
export var MODAL_FOOTER_PADDING_Y = '24px';
export var MODAL_CLOSE_BUTTON_SIZE = '16px';
export var MODAL_CLOSE_BUTTON_OFFSET = '24px';
export var MODAL_SHORT_HEIGHT = '250px';
export var MODAL_MEDIUM_HEIGHT = '408px';
export var MODAL_TALL_HEIGHT = '700px';
export var MODAL_OVERLAY_PADDING_Y = '60px';
export var MODAL_PANEL_PADDING_X = '40px';
export var MODAL_PANEL_PADDING_Y = '24px';
export var MODAL_PANEL_HEADER_PADDING_Y = '26px';
export var MODAL_PANEL_FOOTER_PADDING_Y = '20px';
export var TEXT_AREA_CODE_HEIGHT = '155px';
export var TOOLBAR_HEIGHT_DARK = '56px';
export var TOOLTIP_MAX_WIDTH = '232px';
export var TOOLTIP_FONT_SIZE = '13px';
export var TOOLTIP_LONGFORM_FONT_SIZE = '12px';
export var TOOLTIP_LONGFORM_PADDING = '20px';
export var TOOLTIP_PADDING = '10px';
export var TOOLTIP_PADDING_Y = '10px';
export var TOOLTIP_PADDING_X = '16px';
export var POPOVER_PADDING_Y = '20px';
export var POPOVER_PADDING_X = '24px';
export var SHEPHERD_PADDING_Y = '16px';
export var DROPDOWN_MENU_HEIGHT = '220px';
export var DROPDOWN_ITEM_DEFAULT_HEIGHT = '40px';
export var DROPDOWN_FONT_SIZE = '14px';
export var DROPDOWN_PADDING_Y = '8px';
export var DROPDOWN_PADDING_X = '20px';
export var DROPDOWN_CARET_OFFSET_X = '16px';
export var TAB_FONT_SIZE = '14px';
export var TAB_INDICATOR_HEIGHT = '5px';
export var TAB_PADDING_Y = '12px';
export var TAB_PADDING_X = '28px';
export var TOGGLE_BUTTON_SIZE = '20px';
export var TOGGLE_BUTTON_SIZE_SMALL = '16px';
export var HEADER_PADDING_TOP = '20px';
export var HEADER_PADDING_BOTTOM = '20px';
export var LAYOUT_MAIN_PADDING_TOP = '20px';
export var LAYOUT_MAX_WIDTH = '1280px';
export var LAYOUT_NARROW_WIDTH = '1140px';
export var LAYOUT_PADDING_X = '48px';
export var LAYOUT_EDITOR_PADDING = '20px';
export var BACK_BUTTON_ARROW_SIZE = '22px';
export var BADGE_FONT_SIZE = '14px';
export var BADGE_ROUNDED_FONT_SIZE = '10px';
export var BADGE_ROUNDED_HEIGHT = '20px';
export var TAG_FONT_SIZE = '12px';
export var TAG_FONT_SIZE_LARGE = '14px';
export var TAG_HEIGHT = '24px';
export var TAG_PADDING_X = '8px';
export var TAG_PADDING_Y = '0';
export var TAG_ICON_SPACING_X = '8px';
export var MERCURY_LAYER = '1';
export var VENUS_LAYER = '2';
export var EARTH_LAYER = '1000';
export var MARS_LAYER = '1070';
export var JUPITER_LAYER = '1111';
export var SATURN_LAYER = '1112';
export var URANUS_LAYER = '1211';
export var AVATAR_SIZE_EXTRA_SMALL = '24px';
export var AVATAR_SIZE_SMALL = '32px';
export var AVATAR_SIZE_MEDIUM = '48px';
export var AVATAR_SIZE_LARGE = '72px';
export var AVATAR_SIZE_EXTRA_LARGE = '110px';
export var BASE_SHADOW_ALPHA = '.08';
export var BASE_SHADOW_BLUR_RADIUS = '24px';
export var BASE_SHADOW_OFFSET_Y = '1px';
export var GRID_BREAKPOINT_SMALL = '544px';
export var GRID_BREAKPOINT_MEDIUM = '768px';
export var GRID_BREAKPOINT_LARGE = '992px';
export var GRID_BREAKPOINT_EXTRA_LARGE = '1200px';
export var DEVICE_FRAME_DESKTOP_WIDTH_RATIO = '16';
export var DEVICE_FRAME_DESKTOP_HEIGHT_RATIO = '10';
export var DEVICE_FRAME_TABLET_WIDTH_RATIO = '3';
export var DEVICE_FRAME_TABLET_HEIGHT_RATIO = '4';
export var DEVICE_FRAME_MOBILE_WIDTH_RATIO = '9';
export var DEVICE_FRAME_MOBILE_HEIGHT_RATIO = '19.5';
export var DEVICE_FRAME_DESKTOP_HEADER_HEIGHT = '23px';
export var DEVICE_FRAME_TABLET_HEADER_HEIGHT = '7%';
export var DEVICE_FRAME_MOBILE_HEADER_HEIGHT = '7%';
export var DEVICE_FRAME_MOBILE_FOOTER_HEIGHT = '7%';
export var DEVICE_FRAME_TABLET_HEADER_CIRCLE = '10px';
export var DEVICE_FRAME_MOBILE_HEADER_CIRCLE = '5px';
export var DEVICE_FRAME_CAMERA_SPEAKER_SPACING = '4px';
export var DEVICE_FRAME_BORDER_RADIUS = '6px';
export var FOCUS_RING_BORDER_ALPHA = '.5';
export var FOCUS_RING_SHADOW_ALPHA = '.3';
export var FOCUS_RING_SHADOW_SIZES = '0 0 4px 1px';
export var FOCUS_RING_SHADOW_LAST_SIZES = '0 0 0 1px';